export function formatPhoneNumber(phoneNumber) {
  const numericOnly = phoneNumber.replace(/\D/g, "");

  if (numericOnly.length > 12) {
    console.error("Invalid phone number length");
    return phoneNumber.slice(0, 16);
  }

  const areaCode = numericOnly.slice(0, 3);
  const exchangeCode = numericOnly.slice(3, 6);
  const subscriberNumber = numericOnly.slice(6);

  let formattedNumber = `(${areaCode}`;

  if (exchangeCode) {
    formattedNumber += `) ${exchangeCode}`;
  }

  if (subscriberNumber) {
    formattedNumber += `-${subscriberNumber}`;
  }

  if (phoneNumber.length < 14) {
    formattedNumber = formattedNumber.replace(/[(]$/, "");
  }

  return formattedNumber;
}

export function formatSecondsToTime(seconds) {
  if (seconds === null || isNaN(seconds)) {
    return "0:00";
  }

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  const formattedTime = `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;

  return formattedTime;
}
